import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';
import { Link, Spacer } from '@ontruck/orc';
import CostTotal from './CostTotal';

const StyledLink = styled(Link)`
  font-size: 1.4rem;
`;

const DateTitleWithCost = React.memo(
  ({
    style,
    intl,
    date,
    totalCost,
    totalCostCurrency,
    className,
    numberOfItems,
    shipperFilter,
    handleOpenJobsSummaryModal,
  }) => {
    const dateFormats = intl.messages.date_formats;
    const t = intl.messages.containers.Jobs;
    const component = (
      <div className={className}>
        <h2 className="title">{moment(date).calendar(null, dateFormats.table_calendar)} </h2>
        {(!!numberOfItems || totalCost !== null) && (
          <div>
            (
            {!!numberOfItems && (
              <FormattedMessage
                id={t.number_of_jobs}
                defaultMessage={t.number_of_jobs}
                values={{
                  number: String(numberOfItems),
                }}
              />
            )}
            {totalCost !== null && (
              <Fragment>
                {' '}
                - <CostTotal currency={totalCostCurrency} total={totalCost} />
              </Fragment>
            )}
            )
          </div>
        )}
        {shipperFilter && (
          <Spacer mLeft="XS">
            <StyledLink onClick={handleOpenJobsSummaryModal} text={t.shipperDetails} />
          </Spacer>
        )}
      </div>
    );

    if (!style) {
      return component;
    }

    return <div style={style}>{component}</div>;
  }
);

DateTitleWithCost.propTypes = {
  intl: PropTypes.object,
  date: PropTypes.string.isRequired,
  totalCost: PropTypes.number.isRequired,
  totalCostCurrency: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  numberOfItems: PropTypes.number.isRequired,
  style: PropTypes.shape({}),
};

DateTitleWithCost.defaultProps = {};

export default DateTitleWithCost;
